// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DynamicSearchInputs_wrapper__3OvBn","item":"DynamicSearchInputs_item__3g2T3"};